import { Box, Typography } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ResponsiveContainer,
} from 'recharts';
import { styles } from './styles';
import { BarTopLabel, ChartLegend, DeltaRow, getBarDomain, RoundedBar } from './utils';

const TripsMonthlyChart = ({
    data,
    emergencySites = [],
    selectedEmergencySite,
    onEmergencySiteChange
}) => {

    console.log("djfhskfdjfs", data)

    const chartData = (data || [])
        .filter(d => d.currentMonthTrips > 0 || d.prevMonthTrips > 0)
        .map(d => ({
            month: d.monthLabel || d.month,
            current: d.currentMonthTrips,      // ✅ Changed from "Current Month"
            prev: d.prevMonthTrips,            // ✅ Changed from "Previous Month"
            delta: d.currentMonthTrips - d.prevMonthTrips,
            isIncrease: d.currentMonthTrips >= d.prevMonthTrips,
        }));

    console.log("chartData deltas", chartData.map(d => ({ month: d.month, delta: d.delta })));

    // ✅ Create deltas array for DeltaRow
    const deltas = chartData.map(d => ({
        day: d.month,
        delta: d.delta
    }));

    return (
        <Box sx={styles.chartCard}>
            {/* Header */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 0.5,
                gap: 1,
            }}>
                <Typography sx={styles.chartTitle}>
                    📊 Trips — Month Wise comparison
                </Typography>

                <Box sx={{
                    display: 'flex',
                    gap: 1.5,
                    alignItems: 'center',
                }}>
                    {/* Dropdown */}
                    <select
                        value={selectedEmergencySite?.siteId || ''}
                        onChange={(e) => {
                            const site = emergencySites.find(s => s.siteId == e.target.value);
                            onEmergencySiteChange(site || null);
                        }}
                        style={{
                            padding: '6px 12px',
                            borderRadius: 5,
                            border: '1px solid #d1d5db',
                            fontSize: 12,
                            color: '#374151',
                            fontWeight: 500,
                            cursor: 'pointer',
                            outline: 'none',
                            background: '#fff',
                            minWidth: '140px',
                        }}
                    >
                        <option value="">All Sites</option>
                        {emergencySites && emergencySites.length > 0 && emergencySites.map((site) => (
                            <option key={site.siteId} value={site.siteId}>
                                {site.siteName}
                            </option>
                        ))}
                    </select>
                    {/* ✅ Add custom labels for Monthly */}
                    <ChartLegend
                        currentColor="#1a3a7c"
                        prevColor="#a8b8d8"
                        currentLabel="Current Year"
                        prevLabel="Previous Year"
                    />
                </Box>
            </Box>

            {/* ✅ Use DeltaRow component */}
            <DeltaRow deltas={deltas} />

            <ResponsiveContainer width="100%" height={280}>
                <BarChart data={chartData} barGap={2} margin={{ top: 16, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid vertical={false} stroke="#f0f0f0" />
                    <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fontSize: 12 }} />
                    <YAxis domain={getBarDomain(chartData)} tickCount={6} axisLine={false} tickLine={false} tick={{ fontSize: 13 }} />
                    <Tooltip
                        contentStyle={{
                            background: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: 6,
                            fontSize: 12,
                        }}
                        formatter={(value) => value.toLocaleString()}
                    />

                    <Bar dataKey="current" fill="#1a3a7c" maxBarSize={32} label={<BarTopLabel />} shape={<RoundedBar />} />
                    <Bar dataKey="prev" fill="#a8b8d8" maxBarSize={32} label={<BarTopLabel />} shape={<RoundedBar />} />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};

export default TripsMonthlyChart;